
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function HeroSlider() {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/1b060406de9c1ae14201929b1599411f.jpg',
      title: t('heroTitle'),
      subtitle: t('heroSubtitle'),
      description: t('heroDescription')
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20interior%20room%20being%20painted%20with%20professional%20equipment%2C%20modern%20living%20room%20with%20fresh%20paint%2C%20elegant%20home%20interior%20design%2C%20natural%20lighting%2C%20premium%20paint%20finish%2C%20professional%20painting%20tools&width=1920&height=800&seq=hero2&orientation=landscape',
      title: t('heroInteriorTitle'),
      subtitle: t('heroInteriorSubtitle'),
      description: t('heroInteriorDescription')
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Commercial%20building%20exterior%20painting%20project%2C%20professional%20painters%20working%20on%20office%20building%2C%20modern%20commercial%20property%2C%20industrial%20painting%20equipment%2C%20high%20quality%20commercial%20paint%20job%2C%20Atlanta%20cityscape%20background&width=1920&height=800&seq=hero3&orientation=landscape',
      title: t('heroCommercialTitle'),
      subtitle: t('heroCommercialSubtitle'),
      description: t('heroCommercialDescription')
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5_000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="relative h-[600px] lg:h-[700px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          <div className="absolute inset-0 bg-black/40" />
          
          <div className="relative h-full flex items-center">
            <div className="container mx-auto px-4">
              <div className="max-w-3xl text-white">
                <h1 className="text-4xl lg:text-6xl font-bold mb-4 leading-tight">
                  {slide.title}
                </h1>
                <h2 className="text-xl lg:text-2xl mb-6 text-blue-200">
                  {slide.subtitle}
                </h2>
                <p className="text-lg lg:text-xl mb-8 text-gray-200 max-w-2xl">
                  {slide.description}
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link to="/contact">
                    <Button size="lg" className="w-full sm:w-auto">
                      <i className="ri-phone-fill"></i>
                      {t('getQuote')}
                    </Button>
                  </Link>
                  <a href="tel:770-875-6990">
                    <Button variant="outline" size="lg" className="w-full sm:w-auto bg-white/10 border-white text-white hover:bg-white hover:text-gray-900">
                      <i className="ri-phone-line"></i>
                      {t('callNow')}
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Slide Indicators */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300"
      >
        <i className="ri-arrow-left-line text-xl"></i>
      </button>
      <button
        onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-all duration-300"
      >
        <i className="ri-arrow-right-line text-xl"></i>
      </button>
    </div>
  );
}
